<template>
  <div class="container application">
    <div class="term-desc">
      <ul class="steps-indicator steps-indicator_join">
        <li
          v-for="(label, idx) in steps"
          :key="idx"
          :class="{ active: (step === (idx + 1)) }"
          :style="style"
          class="step"
        >
          <em>{{ idx + 1 }}</em><span>{{ label }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepIndicator',
  props: {
    steps: {
      type: Array,
      default: () => (['약관/보증', '인수정보', '결제정보', '계약완료']),
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    style() {
      return {
        width: `${100 / this.steps.length}%`,
      };
    },
  },
};
</script>

<style scoped>

</style>
